import React from "react";
import "../global.css";
import bgTaxi from "../assets/bg-taxi.png";

const Services = () => {
  return (
    <div
      className="services-page"
      style={{
        backgroundImage: `linear-gradient(rgba(0,0,0,0.55), rgba(0,0,0,0.75)), url(${bgTaxi})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        color: "#fff",
        minHeight: "100vh",
        padding: "80px 20px",
      }}
    >
      <div className="terms-container">
        <h1 className="terms-title">Our Services</h1>
        <p>
          <strong>CheapCabGrab Group</strong> operates in three integrated sectors — 
          <strong>Taxi Transport</strong>, <strong>Home Food</strong>, and <strong>Technology Solutions</strong>.  
          Each division reflects our core values of trust, innovation, and social responsibility.
        </p>

        {/* 🚖 Taxi Section */}
        <h2>🚖 CheapCabGrab – Licensed Airport & City Transfers</h2>
        <p>
          We provide reliable and affordable airport & city transfers using only 
          <strong> licensed, council-approved private hire drivers</strong>.  
          Our service standards strictly comply with <strong>Slough Council</strong> regulations and 
          other local authority licensing frameworks.
        </p>

        <ul>
          <li>✅ Only <strong>licensed private hire drivers</strong></li>
          <li>✅ <strong>Disability Awareness</strong> and <strong>Safeguarding</strong> trained</li>
          <li>✅ <strong>Enhanced DBS checked</strong> and continuously tracked</li>
          <li>✅ All cars are <strong>electric, hybrid, or plug-in hybrid</strong></li>
          <li>✅ No vehicle older than <strong>6 years</strong> is accepted</li>
        </ul>

        <p>
          We ensure high safety, professionalism, and comfort for every passenger, 
          while working toward a fully electric, zero-emission fleet by 2027.
        </p>

        <p>
          To book your next journey, visit <strong>CheapCabGrab.com</strong> or email  
          <a href="mailto:info@cheapcabgrab.com" style={{ color: "#ffc107" }}> info@cheapcabgrab.com</a>.
        </p>

        <hr style={{ borderColor: "#666", margin: "2rem 0" }} />

        {/* 🍲 Food Section */}
        <h2>🍲 HomeFoodGrab – Local Food, Made Fresh</h2>
        <p>
          <strong>HomeFoodGrab</strong> empowers local home cooks to turn their passion for 
          food into income, while promoting sustainability and community well-being.  
          We partner with councils to ensure every seller is <strong>registered, inspected, and authentic</strong>.
        </p>

        <ul>
          <li>🌿 <strong>Empowerment:</strong> Supporting independent cooks and family kitchens</li>
          <li>♻️ <strong>Environment:</strong> Minimising food waste and packaging through local deliveries</li>
          <li>✅ <strong>Authenticity:</strong> Council-verified sellers for safety and hygiene compliance</li>
        </ul>

        <p>
          Start your journey:
        </p>
        <ul>
          <li>
            🍴 Become a Seller:{" "}
            <a href="https://www.homefoodgrab.com/seller" style={{ color: "#ffc107" }}>
              www.homefoodgrab.com/seller
            </a>
          </li>
          <li>
            🚗 Become a Delivery Driver:{" "}
            <a href="https://www.homefoodgrab.com/driver" style={{ color: "#ffc107" }}>
              www.homefoodgrab.com/driver
            </a>
          </li>
        </ul>

        <p>
          For all food platform queries, contact{" "}
          <a href="mailto:info@homefoodgrab.com" style={{ color: "#ffc107" }}>
            info@homefoodgrab.com
          </a>.
        </p>

        <hr style={{ borderColor: "#666", margin: "2rem 0" }} />

        {/* 💻 IT Services */}
        <h2>💻 CCG Technologies – AI, Cybersecurity & Development</h2>
        <p>
          Our technology arm, <strong>CCG Technologies</strong>, provides 
          enterprise-grade IT consultancy and development solutions across the UK.  
          We specialise in automation, security, and digital transformation.
        </p>

        <ul>
          <li>🤖 <strong>AI Integration:</strong> Deploy intelligent automation to save time and money</li>
          <li>🔐 <strong>Cybersecurity:</strong> Security testing, compliance, and proactive protection of customer data</li>
          <li>🧠 <strong>ML / AI Agents:</strong> Create workflow automation with intelligent agents</li>
          <li>🌐 <strong>Full-Stack Development:</strong> Design, develop, and maintain modern web & mobile apps</li>
        </ul>

        <p>
          To learn how we can help your business grow through technology, email{" "}
          <a href="mailto:info@cheapcabgrab.com" style={{ color: "#ffc107" }}>
            info@cheapcabgrab.com
          </a>.
        </p>

        <hr style={{ borderColor: "#666", margin: "2rem 0" }} />

        <h3>📍 Company Overview</h3>
        <p>
          <strong>CheapCabGrab Group Ltd</strong> – UK Registered Company <br />
          SIC Codes: 49320 (Taxi Operation), 56290 (Food Services), 62020 (IT Consultancy) <br />
          Operating ethically with compliance, transparency, and customer trust at its core.
        </p>
      </div>

      {/* Floating Book Now Button */}
      <button
        className="floating-book-btn"
        onClick={() => (window.location.href = "/")}
      >
        🚖 Book Now
      </button>
    </div>
  );
};

export default Services;

